(function (global) {
  'use strict';

  var ROOT_SELECTOR = '[data-qy-garden]';
  var VIEWER_SELECTOR = '[data-qiyuan-3d-root]';
  var VIEWER_SCRIPT_SELECTOR = 'script[data-qiyuan-shared-viewer]';
  var HALLS = ['guanyin', 'dizang', 'caishen', 'pet'];
  var ACTIONS = ['lamp', 'incense', 'message'];
  var DURATIONS = ['1-day', '3-days', '7-days', '1-month', '1-year'];
  var SOURCE = 'homepage garden';
  var controllers = typeof WeakMap === 'function' ? new WeakMap() : null;
  var parkedViewers = new Map();
  var viewerLoader = {
    promise: null,
    url: '',
  };

  if (global.QiyuanEasternMemorialGarden && global.QiyuanEasternMemorialGarden.version) {
    if (global.document && global.QiyuanEasternMemorialGarden.init) {
      global.QiyuanEasternMemorialGarden.init(global.document);
    }
    return;
  }

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function matches(element, selector) {
    return Boolean(element && element.matches && element.matches(selector));
  }

  function queryAll(scope, selector) {
    return scope && scope.querySelectorAll ? toArray(scope.querySelectorAll(selector)) : [];
  }

  function rootsWithin(scope) {
    var roots = [];

    if (matches(scope, ROOT_SELECTOR)) roots.push(scope);
    queryAll(scope, ROOT_SELECTOR).forEach(function (root) {
      if (roots.indexOf(root) === -1) roots.push(root);
    });

    return roots;
  }

  function isHall(value) {
    return HALLS.indexOf(value) !== -1;
  }

  function isDuration(value) {
    return DURATIONS.indexOf(value) !== -1;
  }

  function isAction(value) {
    return ACTIONS.indexOf(value) !== -1;
  }

  function cleanString(value) {
    return value === null || value === undefined ? '' : String(value).trim();
  }

  function variantId(value) {
    var normalized = cleanString(value);
    return /^\d+$/.test(normalized) ? normalized : '';
  }

  function actionLabel(scene, action, config) {
    var sceneConfig = config && config.scenes ? config.scenes[scene] : null;

    if (action === 'lamp') return 'Light a Lamp';
    if (action === 'incense') return 'Offer Incense';
    if (action === 'message') {
      return cleanString(sceneConfig && sceneConfig.messageAction) || 'Leave a Message';
    }
    return '';
  }

  function getOffering(config, scene, action, duration) {
    var durationConfig =
      config && config.durations && isDuration(duration) ? config.durations[duration] : null;
    var id = '';
    var price = '';

    if (
      !isHall(scene) ||
      !isAction(action) ||
      !durationConfig ||
      (scene === 'pet' && action === 'incense')
    ) {
      return {
        available: false,
        kind: 'unavailable',
        action: action,
        label: actionLabel(scene, action, config),
        duration: duration,
        durationLabel: cleanString(durationConfig && durationConfig.label),
        variantId: '',
        price: '',
      };
    }

    id = variantId(durationConfig.variantId);
    price = cleanString(durationConfig.price);

    return {
      available: Boolean(id && price),
      kind: id && price ? 'paid' : 'unavailable',
      action: action,
      label: actionLabel(scene, action, config),
      duration: duration,
      durationLabel: cleanString(durationConfig.label),
      variantId: id,
      price: price,
    };
  }

  function buildLineItemProperties(selection) {
    return {
      Hall: cleanString(selection && selection.hall),
      'Dedication Type': cleanString(selection && selection.dedicationType),
      Duration: cleanString(selection && selection.duration),
      'Name or Names': cleanString(selection && selection.names),
      Recipient: cleanString(selection && selection.recipient),
      Privacy: cleanString(selection && selection.privacy),
      Email: cleanString(selection && selection.email),
      Message: cleanString(selection && selection.message),
      'Newsletter Consent': selection && selection.newsletterConsent ? 'Yes' : 'No',
      Source: SOURCE,
    };
  }

  function buildCartPayload(selection) {
    return {
      items: [
        {
          id: selection && selection.offering ? selection.offering.variantId : '',
          quantity: 1,
          properties: buildLineItemProperties(selection),
        },
      ],
    };
  }

  function parseConfig(root) {
    var configNode = root && root.querySelector
      ? root.querySelector('[data-qy-garden-config]')
      : null;

    if (!configNode) return {};

    try {
      return JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function sectionId(root) {
    return root && root.getAttribute
      ? root.getAttribute('data-section-id') || root.id || ''
      : '';
  }

  function getController(root) {
    return controllers ? controllers.get(root) : root.__qiyuanGardenController;
  }

  function setController(root, controller) {
    if (controllers) controllers.set(root, controller);
    else root.__qiyuanGardenController = controller;
  }

  function removeController(root) {
    if (controllers) controllers.delete(root);
    else delete root.__qiyuanGardenController;
  }

  function loadViewerScript(root) {
    var document = global.document;
    var url = root && root.getAttribute ? cleanString(root.getAttribute('data-viewer-src')) : '';

    if (!document || !url) {
      return Promise.reject(new Error('The Qiyuan 3D viewer URL is missing.'));
    }

    if (viewerLoader.promise) {
      if (viewerLoader.url && viewerLoader.url !== url) {
        return Promise.reject(new Error('A different Qiyuan 3D viewer is already loaded.'));
      }
      return viewerLoader.promise;
    }

    viewerLoader.url = url;
    viewerLoader.promise = new Promise(function (resolve, reject) {
      var script = document.querySelector(VIEWER_SCRIPT_SELECTOR);

      function handleLoad() {
        script.setAttribute('data-qiyuan-viewer-state', 'loaded');
        resolve(script);
      }

      function handleError() {
        script.setAttribute('data-qiyuan-viewer-state', 'error');
        viewerLoader.promise = null;
        reject(new Error('The Qiyuan 3D viewer script could not be loaded.'));
      }

      if (script) {
        if (script.getAttribute('data-qiyuan-viewer-state') === 'loaded') {
          resolve(script);
          return;
        }

        if (script.getAttribute('data-qiyuan-viewer-state') === 'error') {
          viewerLoader.promise = null;
          reject(new Error('The Qiyuan 3D viewer script could not be loaded.'));
          return;
        }

        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
        return;
      }

      script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.setAttribute('data-qiyuan-shared-viewer', 'true');
      script.setAttribute('data-qiyuan-viewer-state', 'loading');
      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });
      document.head.appendChild(script);
    });

    return viewerLoader.promise;
  }

  function copyViewerConfiguration(source, target) {
    if (source.id) target.id = source.id;
  }

  function restoreParkedViewer(root) {
    var id = sectionId(root);
    var parked = id ? parkedViewers.get(id) : null;
    var placeholder = root && root.querySelector ? root.querySelector(VIEWER_SELECTOR) : null;

    if (!parked || !placeholder || !placeholder.parentNode) return null;

    copyViewerConfiguration(placeholder, parked);
    placeholder.parentNode.replaceChild(parked, placeholder);
    parkedViewers.delete(id);
    return parked;
  }

  function parkViewers(scope) {
    rootsWithin(scope).forEach(function (root) {
      var controller = getController(root);
      var id = sectionId(root);
      var viewer = root.querySelector(VIEWER_SELECTOR);

      if (controller) controller.disconnect();
      removeController(root);
      if (!id || !viewer) return;

      parkedViewers.set(id, viewer);
      global.document.createDocumentFragment().appendChild(viewer);
    });
  }

  function GardenController(root) {
    this.root = root;
    this.config = parseConfig(root);
    this.activeScene = 'garden';
    this.activeAction = 'lamp';
    this.duration = '1-day';
    this.currentOffering = null;
    this.connected = false;
    this.allowNativeContactSubmit = false;
    this.submitting = false;
    this.pendingScene = '';
    this.pendingSlot = '';
    this.currentSlot = '';
    this.loadedScene = '';
    this.slotScenes = {
      guanyin: '',
      dizang: '',
    };
    this.wasAutoRotating = false;
    this.isNearViewport = !global.IntersectionObserver;
    this.showUnavailableOfferings = Boolean(
      this.config && this.config.showUnavailableOfferings
    );

    this.stage = root.querySelector('[data-qy-stage]');
    this.sceneTitle = root.querySelector('[data-qy-scene-title]');
    this.sceneKicker = root.querySelector('[data-qy-scene-kicker]');
    this.returnButton = root.querySelector('[data-qy-return]');
    this.entrances = root.querySelector('[data-qy-entrances]');
    this.entryButtons = queryAll(root, '[data-qy-enter-hall]');
    this.hallContent = root.querySelector('[data-qy-hall-content]');
    this.hallTitle = root.querySelector('[data-qy-hall-title]');
    this.hallSummary = root.querySelector('[data-qy-hall-summary]');
    this.fallbackScenes = queryAll(root, '[data-qy-fallback-scene]');
    this.fallbackStatus = root.querySelector('[data-qy-fallback-status]');
    this.modelView = root.querySelector('[data-qy-model-view]');
    this.viewerControls = root.querySelector('[data-qy-viewer-controls]');
    this.viewer = root.querySelector(VIEWER_SELECTOR);
    this.viewerStatus = this.viewer
      ? this.viewer.querySelector('[data-qiyuan-status]')
      : null;
    this.rotateButton = this.viewer
      ? this.viewer.querySelector('[data-qiyuan-rotate]')
      : null;

    this.dedicationForm = root.querySelector('[data-qy-dedication-form]');
    this.newsletterForm = root.querySelector('.qcg-newsletter-form form');
    this.actionButtons = queryAll(root, '[data-qy-action]');
    this.durationField = root.querySelector('[data-qy-duration]');
    this.durationOptions = this.durationField
      ? queryAll(this.durationField, 'option')
      : [];
    this.namesField = root.querySelector('[data-qy-names]');
    this.recipientField = root.querySelector('[data-qy-recipient]');
    this.privacyField = root.querySelector('[data-qy-privacy]');
    this.emailField = root.querySelector('[data-qy-email]');
    this.messageField = root.querySelector('[data-qy-message]');
    this.newsletterConsent = root.querySelector('[data-qy-newsletter-consent]');
    this.previewPanel = root.querySelector('[data-qy-preview-panel]');
    this.confirmButton = root.querySelector('[data-qy-confirm]');
    this.submitError = root.querySelector('[data-qy-submit-error]');
    this.motionQuery =
      global.matchMedia && typeof global.matchMedia === 'function'
        ? global.matchMedia('(prefers-reduced-motion: reduce)')
        : null;
    this.intersectionObserver = null;
    this.viewerObserver = null;

    this.handleClick = this.handleClick.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleModelReady = this.handleModelReady.bind(this);
    this.handleMotionChange = this.handleMotionChange.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  GardenController.prototype.sceneConfig = function (scene) {
    return this.config && this.config.scenes ? this.config.scenes[scene] || null : null;
  };

  GardenController.prototype.modelUrl = function (scene) {
    var sceneConfig = this.sceneConfig(scene);
    return cleanString(sceneConfig && sceneConfig.modelUrl);
  };

  GardenController.prototype.setFallbackScene = function (scene) {
    this.fallbackScenes.forEach(function (fallback) {
      var selected = fallback.getAttribute('data-qy-fallback-scene') === scene;
      fallback.hidden = !selected;
      fallback.setAttribute('aria-hidden', selected ? 'false' : 'true');
    });
  };

  GardenController.prototype.setFallbackMessage = function (message, visible) {
    if (!this.fallbackStatus) return;
    this.fallbackStatus.textContent = message;
    this.fallbackStatus.hidden = !visible;
  };

  GardenController.prototype.setMediaAccessibility = function (state) {
    var fallbackStack = this.root.querySelector('[data-qy-fallback-stack]');
    var canvas = this.viewer ? this.viewer.querySelector('[data-qiyuan-canvas]') : null;
    var viewerIsReady = state === 'ready';
    var viewerIsPresent = state === 'ready' || state === 'loading';

    if (fallbackStack) {
      fallbackStack.setAttribute('aria-hidden', viewerIsReady ? 'true' : 'false');
    }
    if (this.modelView) {
      this.modelView.setAttribute('aria-hidden', viewerIsPresent ? 'false' : 'true');
    }
    if (canvas) {
      canvas.setAttribute('tabindex', viewerIsReady ? '0' : '-1');
    }
  };

  GardenController.prototype.pauseViewer = function (remember) {
    if (!this.rotateButton) return;
    if (this.rotateButton.getAttribute('aria-pressed') === 'true') {
      if (remember) this.wasAutoRotating = true;
      this.rotateButton.click();
    }
  };

  GardenController.prototype.resumeViewer = function () {
    if (
      !this.rotateButton ||
      !this.wasAutoRotating ||
      (this.motionQuery && this.motionQuery.matches) ||
      this.modelView.hidden
    ) {
      return;
    }

    if (this.rotateButton.getAttribute('aria-pressed') !== 'true') {
      this.rotateButton.click();
    }
    this.wasAutoRotating = false;
  };

  GardenController.prototype.selectModelSlot = function (scene) {
    var url = this.modelUrl(scene);
    var initialized =
      this.viewer && this.viewer.getAttribute('data-qiyuan-initialized') === 'true';
    var activeSlot =
      this.viewer && this.viewer.getAttribute('data-model-kind')
        ? this.viewer.getAttribute('data-model-kind')
        : this.currentSlot;
    var slot;

    if (this.viewer && this.viewer.getAttribute('data-guanyin-src') === url) {
      slot = 'guanyin';
    } else if (this.viewer && this.viewer.getAttribute('data-dizang-src') === url) {
      slot = 'dizang';
    } else if (!initialized && !this.currentSlot) {
      slot = 'guanyin';
    } else if (this.slotScenes.guanyin === scene) {
      slot = 'guanyin';
    } else if (this.slotScenes.dizang === scene) {
      slot = 'dizang';
    } else {
      slot = activeSlot === 'guanyin' ? 'dizang' : 'guanyin';
    }

    return slot;
  };

  GardenController.prototype.configureModel = function (scene) {
    var url = this.modelUrl(scene);
    var slot;
    var attribute;
    var button;
    var description;
    var initialized;
    var activeSlot;

    if (!url || !this.viewer) return;

    if (
      this.loadedScene === scene &&
      (!this.pendingScene || this.pendingScene === scene) &&
      this.viewer.getAttribute('data-qiyuan-initialized') === 'true'
    ) {
      this.root.removeAttribute('data-model-loading');
      if (this.modelView) this.modelView.hidden = false;
      if (this.viewerControls) this.viewerControls.hidden = false;
      this.setMediaAccessibility('ready');
      this.setFallbackMessage('', false);
      this.resumeViewer();
      return;
    }

    slot = this.selectModelSlot(scene);
    initialized = this.viewer.getAttribute('data-qiyuan-initialized') === 'true';
    activeSlot = this.viewer.getAttribute('data-model-kind') || this.currentSlot;
    if (initialized && slot === activeSlot && this.loadedScene !== scene) {
      slot = activeSlot === 'guanyin' ? 'dizang' : 'guanyin';
    }
    attribute = slot === 'guanyin' ? 'data-guanyin-src' : 'data-dizang-src';
    this.viewer.setAttribute(attribute, url);
    this.slotScenes[slot] = scene;
    this.currentSlot = slot;
    this.pendingSlot = slot;
    this.pendingScene = scene;
    this.root.setAttribute('data-model-loading', 'true');
    if (this.viewerControls) this.viewerControls.hidden = true;
    this.setMediaAccessibility('loading');

    description = this.viewer.querySelector('[data-qiyuan-description="' + slot + '"]');
    if (description) {
      var sceneConfig = this.sceneConfig(scene);
      description.textContent =
        cleanString(sceneConfig && sceneConfig.title) + ' interactive 3D scene';
    }

    if (!initialized) {
      this.viewer.setAttribute('data-initial-model', slot);
    }

    this.setFallbackMessage('', false);

    loadViewerScript(this.root)
      .then(
        function () {
          if (!initialized) return;
          button = this.viewer.querySelector('[data-qiyuan-model-btn="' + slot + '"]');
          if (button && !button.disabled) button.click();
        }.bind(this)
      )
      .catch(
        function () {
          if (this.pendingScene !== scene) return;
          this.root.removeAttribute('data-model-loading');
          this.modelView.hidden = true;
          this.viewerControls.hidden = true;
          this.setMediaAccessibility('fallback');
          this.setFallbackMessage(
            'This 3D view is temporarily unavailable. You can continue below.',
            true
          );
        }.bind(this)
      );
  };

  GardenController.prototype.showScene = function (scene) {
    var sceneConfig = this.sceneConfig(scene) || {};
    var url = this.modelUrl(scene);

    this.activeScene = scene;
    this.root.setAttribute('data-active-scene', scene);
    this.setFallbackScene(scene);

    if (this.sceneKicker) this.sceneKicker.textContent = cleanString(sceneConfig.kicker);
    if (this.sceneTitle) {
      this.sceneTitle.textContent = '';
      this.sceneTitle.appendChild(global.document.createTextNode(cleanString(sceneConfig.title)));
      if (sceneConfig.titleZh) {
        var titleZh = global.document.createElement('span');
        titleZh.lang = 'zh';
        titleZh.textContent = cleanString(sceneConfig.titleZh);
        this.sceneTitle.appendChild(titleZh);
      }
    }

    if (!url) {
      this.pendingScene = '';
      this.pendingSlot = '';
      this.root.removeAttribute('data-model-loading');
      this.pauseViewer(true);
      if (this.modelView) this.modelView.hidden = true;
      if (this.viewerControls) this.viewerControls.hidden = true;
      this.setMediaAccessibility('fallback');
      this.setFallbackMessage('This 3D view is temporarily unavailable.', true);
      return;
    }

    if (!this.isNearViewport) {
      if (this.modelView) this.modelView.hidden = true;
      if (this.viewerControls) this.viewerControls.hidden = true;
      this.setMediaAccessibility('fallback');
      this.setFallbackMessage('', false);
      return;
    }

    if (this.modelView) this.modelView.hidden = false;
    this.configureModel(scene);
  };

  GardenController.prototype.actionAvailable = function (action) {
    var self = this;
    if (action === 'incense' && this.activeScene === 'pet') return false;
    return DURATIONS.some(function (duration) {
      return getOffering(self.config, self.activeScene, action, duration).available;
    });
  };

  GardenController.prototype.syncActionButtons = function () {
    var self = this;

    this.actionButtons.forEach(function (button) {
      var action = button.getAttribute('data-qy-action');
      var applicable = !(self.activeScene === 'pet' && action === 'incense');
      var available = applicable && self.actionAvailable(action);
      var visible = applicable && (available || self.showUnavailableOfferings);

      button.hidden = !visible;
      button.disabled = !available && !self.showUnavailableOfferings;
      button.setAttribute('aria-disabled', available ? 'false' : 'true');
    });
  };

  GardenController.prototype.syncDurationOptions = function () {
    var self = this;
    var firstAvailable = '';

    this.durationOptions.forEach(function (option) {
      var duration = option.value;
      var offering = getOffering(
        self.config,
        self.activeScene,
        self.activeAction,
        duration
      );
      var durationConfig =
        self.config && self.config.durations
          ? self.config.durations[duration]
          : null;
      var label = cleanString(durationConfig && durationConfig.label) || option.textContent;

      if (offering.available && !firstAvailable) firstAvailable = duration;
      option.disabled = !offering.available;
      option.hidden = !offering.available && !self.showUnavailableOfferings;
      option.textContent =
        offering.available
          ? label + ' — ' + offering.price
          : label + (self.showUnavailableOfferings ? ' — Not yet available' : '');
    });

    if (
      !getOffering(
        this.config,
        this.activeScene,
        this.activeAction,
        this.duration
      ).available &&
      !this.showUnavailableOfferings &&
      firstAvailable
    ) {
      this.duration = firstAvailable;
      if (this.durationField) this.durationField.value = firstAvailable;
    }
  };

  GardenController.prototype.updateHallContent = function (scene) {
    var sceneConfig = this.sceneConfig(scene) || {};
    var messageButton = this.root.querySelector('[data-qy-action="message"]');
    var messageActionLabel = this.root.querySelector('[data-qy-message-action-label]');
    var messageLabel = this.root.querySelector('[data-qy-message-label]');

    if (this.hallTitle) {
      this.hallTitle.textContent = '';
      this.hallTitle.appendChild(global.document.createTextNode(cleanString(sceneConfig.title)));
      if (sceneConfig.titleZh) {
        var titleZh = global.document.createElement('span');
        titleZh.lang = 'zh';
        titleZh.textContent = cleanString(sceneConfig.titleZh);
        this.hallTitle.appendChild(titleZh);
      }
    }
    if (this.hallSummary) this.hallSummary.textContent = cleanString(sceneConfig.summary);
    if (messageActionLabel) {
      messageActionLabel.textContent = cleanString(sceneConfig.messageAction) || 'Leave a Message';
    }
    if (messageButton) {
      messageButton.setAttribute(
        'aria-label',
        cleanString(sceneConfig.messageAction) || 'Leave a Message'
      );
    }
    if (messageLabel) {
      messageLabel.textContent = cleanString(sceneConfig.messageLabel) || 'Message';
    }
    if (this.messageField) {
      this.messageField.placeholder = cleanString(sceneConfig.messagePlaceholder);
    }

    if (scene === 'pet' && this.activeAction === 'incense') this.activeAction = 'lamp';
    this.syncActionButtons();
    this.selectAction(this.activeAction, false);
  };

  GardenController.prototype.scrollToScene = function (focusHeading) {
    var self = this;
    if (!focusHeading) return;

    if (this.sceneTitle) this.sceneTitle.focus({ preventScroll: true });
    if (!this.stage || !this.stage.scrollIntoView) return;

    global.requestAnimationFrame(function () {
      self.stage.scrollIntoView({
        behavior: self.prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  };

  GardenController.prototype.enterHall = function (scene, focusHeading) {
    if (!isHall(scene)) return;

    this.isNearViewport = true;
    this.entryButtons.forEach(function (button) {
      button.setAttribute(
        'aria-expanded',
        button.getAttribute('data-qy-enter-hall') === scene ? 'true' : 'false'
      );
    });
    if (this.returnButton) this.returnButton.hidden = false;
    if (this.entrances) this.entrances.hidden = true;
    if (this.hallContent) this.hallContent.hidden = false;
    this.hidePreview();
    this.clearSubmitError();
    this.showScene(scene);
    this.updateHallContent(scene);
    this.scrollToScene(focusHeading);
  };

  GardenController.prototype.returnToGarden = function (focusHeading) {
    this.entryButtons.forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
    if (this.returnButton) this.returnButton.hidden = true;
    if (this.entrances) this.entrances.hidden = false;
    if (this.hallContent) this.hallContent.hidden = true;
    this.hidePreview();
    this.clearSubmitError();
    this.showScene('garden');
    this.scrollToScene(focusHeading);
  };

  GardenController.prototype.selectAction = function (action, userInitiated) {
    if (['lamp', 'incense', 'message'].indexOf(action) === -1) return;
    if (this.activeScene === 'pet' && action === 'incense') action = 'lamp';
    if (!this.actionAvailable(action) && !this.showUnavailableOfferings) {
      action = ['lamp', 'message', 'incense'].find(
        function (candidate) {
          return this.actionAvailable(candidate);
        }.bind(this)
      ) || 'lamp';
    }

    this.activeAction = action;
    this.actionButtons.forEach(function (button) {
      var selected = button.getAttribute('data-qy-action') === action;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    this.syncDurationOptions();
    this.updateSelectionStatus();
    if (userInitiated) {
      this.hidePreview();
      this.clearSubmitError();
    }
  };

  GardenController.prototype.updateSelectionStatus = function () {
    var priceNode = this.root.querySelector('[data-qy-selection-price]');
    var noteNode = this.root.querySelector('[data-qy-mapping-note]');
    var offering = getOffering(
      this.config,
      this.activeScene,
      this.activeAction,
      this.duration
    );

    this.currentOffering = offering;
    if (!priceNode || !noteNode) return;

    if (offering.kind === 'paid') {
      priceNode.textContent =
        offering.label + ' · ' + offering.durationLabel + ' · ' + offering.price;
      noteNode.textContent = 'Continue through Shopify checkout.';
    } else {
      priceNode.textContent = 'Not yet available';
      noteNode.textContent = 'Please choose another dedication option.';
    }
  };

  GardenController.prototype.selection = function () {
    var offering = getOffering(
      this.config,
      this.activeScene,
      this.activeAction,
      this.duration
    );
    var sceneConfig = this.sceneConfig(this.activeScene) || {};

    return {
      hall: cleanString(sceneConfig.title),
      dedicationType: offering.label,
      duration: offering.durationLabel,
      names: cleanString(this.namesField && this.namesField.value),
      recipient: cleanString(this.recipientField && this.recipientField.value),
      privacy: cleanString(this.privacyField && this.privacyField.value),
      email: cleanString(this.emailField && this.emailField.value),
      message: cleanString(this.messageField && this.messageField.value),
      newsletterConsent: Boolean(this.newsletterConsent && this.newsletterConsent.checked),
      offering: offering,
    };
  };

  GardenController.prototype.validateFields = function () {
    var fields = [
      this.namesField,
      this.recipientField,
      this.privacyField,
      this.emailField,
      this.messageField,
    ];
    if (this.namesField) {
      this.namesField.setCustomValidity(
        cleanString(this.namesField.value) ? '' : 'Please enter at least one name.'
      );
    }
    if (this.messageField) {
      this.messageField.setCustomValidity(
        cleanString(this.messageField.value) ? '' : 'Please enter a wish or remembrance message.'
      );
    }
    if (this.recipientField) {
      this.recipientField.setCustomValidity(
        cleanString(this.recipientField.value) ? '' : 'Please enter the dedication recipient.'
      );
    }
    var invalid = fields.find(function (field) {
      return field && !field.checkValidity();
    });

    if (invalid) {
      invalid.reportValidity();
      invalid.focus();
      return false;
    }

    return true;
  };

  GardenController.prototype.fillPreview = function (selection) {
    var flow;
    var values = {
      '[data-qy-preview-hall]': selection.hall,
      '[data-qy-preview-type]': selection.dedicationType,
      '[data-qy-preview-duration]': selection.duration,
      '[data-qy-preview-names]': selection.names,
      '[data-qy-preview-recipient]': selection.recipient,
      '[data-qy-preview-privacy]': selection.privacy,
      '[data-qy-preview-email]': selection.email,
      '[data-qy-preview-message]': selection.message,
      '[data-qy-preview-consent]': selection.newsletterConsent ? 'Yes' : 'No',
    };

    if (selection.offering.kind === 'paid') {
      flow =
        selection.offering.price +
        ' through Shopify checkout. Order and payment status are created by Shopify.';
    } else {
      flow = 'This dedication option is not currently available.';
    }
    values['[data-qy-preview-flow]'] = flow;

    Object.keys(values).forEach(
      function (selector) {
        var node = this.root.querySelector(selector);
        if (node) node.textContent = values[selector];
      }.bind(this)
    );

    if (this.confirmButton) {
      this.confirmButton.disabled = selection.offering.kind === 'unavailable';
      this.confirmButton.textContent =
        selection.offering.kind === 'paid' ? 'Continue to Payment' : 'Not yet available';
    }
  };

  GardenController.prototype.preview = function () {
    var selection;

    this.clearSubmitError();
    if (!this.validateFields()) return;

    selection = this.selection();
    this.fillPreview(selection);
    if (this.previewPanel) {
      this.previewPanel.hidden = false;
      this.previewPanel.focus({ preventScroll: true });
      this.previewPanel.scrollIntoView({ behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest' });
    }
  };

  GardenController.prototype.hidePreview = function () {
    if (this.previewPanel) this.previewPanel.hidden = true;
  };

  GardenController.prototype.clearSubmitError = function () {
    if (!this.submitError) return;
    this.submitError.hidden = true;
    this.submitError.textContent = '';
  };

  GardenController.prototype.showSubmitError = function (message) {
    if (!this.submitError) return;
    this.submitError.textContent =
      cleanString(message) ||
      'Something went wrong. Your selection was not submitted. Please try again.';
    this.submitError.hidden = false;
    this.submitError.focus({ preventScroll: true });
  };

  GardenController.prototype.prefersReducedMotion = function () {
    return Boolean(this.motionQuery && this.motionQuery.matches);
  };

  GardenController.prototype.submitNewsletterIfConsented = function (selection) {
    var email;
    var formData;

    if (!selection.newsletterConsent) return Promise.resolve();
    if (!this.newsletterForm || !global.fetch) {
      return Promise.reject(new Error('The Shopify newsletter form is unavailable.'));
    }

    email = this.newsletterForm.querySelector('[data-qy-newsletter-email]');
    if (email) email.value = selection.email;
    formData = new global.FormData(this.newsletterForm);

    return global
      .fetch(this.newsletterForm.action, {
        method: (this.newsletterForm.method || 'post').toUpperCase(),
        body: formData,
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
        },
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Qiyuan Letters signup could not be confirmed.');
        }
        return response.text().then(function (html) {
          var responseUrl = response.url ? new global.URL(response.url, global.location.href) : null;
          var confirmedByUrl =
            responseUrl && responseUrl.searchParams.get('customer_posted') === 'true';
          var confirmedByMarkup = html.indexOf('data-qy-newsletter-success') !== -1;

          if (!confirmedByUrl && !confirmedByMarkup) {
            throw new Error(
              'Qiyuan Letters signup could not be confirmed. Your dedication was not submitted.'
            );
          }
          return { confirmed: true };
        });
      });
  };

  GardenController.prototype.cartEndpoint = function () {
    var root =
      global.Shopify &&
      global.Shopify.routes &&
      typeof global.Shopify.routes.root === 'string'
        ? global.Shopify.routes.root
        : '/';
    return root.replace(/\/?$/, '/') + 'cart/add.js';
  };

  GardenController.prototype.submitPaidDedication = function (selection) {
    var payload = buildCartPayload(selection);

    if (!global.fetch) {
      return Promise.reject(new Error('Shopify cart access is unavailable in this browser.'));
    }

    return this.submitNewsletterIfConsented(selection)
      .then(
        function () {
          return global.fetch(this.cartEndpoint(), {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });
        }.bind(this)
      )
      .then(function (response) {
        if (response.ok) return response.json();
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (error) {
            throw new Error(
              cleanString(error.description || error.message) ||
                'Shopify could not add this dedication to the cart.'
            );
          });
      })
      .then(function () {
        var root =
          global.Shopify &&
          global.Shopify.routes &&
          typeof global.Shopify.routes.root === 'string'
            ? global.Shopify.routes.root
            : '/';
        global.location.assign(root.replace(/\/?$/, '/') + 'checkout');
      });
  };

  GardenController.prototype.confirm = function () {
    var selection;
    if (this.submitting || !this.validateFields()) return;
    selection = this.selection();
    this.fillPreview(selection);

    if (selection.offering.kind === 'unavailable') {
      this.showSubmitError('This dedication option is not currently available.');
      return;
    }

    this.submitting = true;
    this.clearSubmitError();
    if (this.confirmButton) {
      this.confirmButton.disabled = true;
      this.confirmButton.textContent = 'Opening Shopify checkout…';
    }

    Promise.resolve(this.submitPaidDedication(selection)).catch(
      function (error) {
        this.submitting = false;
        this.fillPreview(selection);
        this.showSubmitError(error && error.message);
      }.bind(this)
    );
  };

  GardenController.prototype.handleClick = function (event) {
    var target = event.target;
    var entryButton = target.closest && target.closest('[data-qy-enter-hall]');
    var actionButton = target.closest && target.closest('[data-qy-action]');

    if (entryButton && this.root.contains(entryButton)) {
      this.enterHall(entryButton.getAttribute('data-qy-enter-hall'), true);
      return;
    }
    if (target.closest && target.closest('[data-qy-return]')) {
      this.returnToGarden(true);
      return;
    }
    if (actionButton && this.root.contains(actionButton)) {
      this.selectAction(actionButton.getAttribute('data-qy-action'), true);
      return;
    }
    if (target.closest && target.closest('[data-qy-preview]')) {
      this.preview();
      return;
    }
    if (target.closest && target.closest('[data-qy-edit]')) {
      this.hidePreview();
      if (this.namesField) this.namesField.focus();
      return;
    }
    if (target.closest && target.closest('[data-qy-confirm]')) {
      this.confirm();
    }
  };

  GardenController.prototype.handleFormSubmit = function (event) {
    event.preventDefault();
    this.preview();
  };

  GardenController.prototype.handleInput = function (event) {
    if (event.target === this.durationField) {
      this.duration = isDuration(this.durationField.value)
        ? this.durationField.value
        : '1-day';
      this.updateSelectionStatus();
    }

    if (
      event.target === this.durationField ||
      event.target === this.namesField ||
      event.target === this.recipientField ||
      event.target === this.privacyField ||
      event.target === this.emailField ||
      event.target === this.messageField ||
      event.target === this.newsletterConsent
    ) {
      if (
        (event.target === this.namesField ||
          event.target === this.recipientField ||
          event.target === this.messageField) &&
        event.target.setCustomValidity
      ) {
        event.target.setCustomValidity('');
      }
      this.hidePreview();
      this.clearSubmitError();
    }
  };

  GardenController.prototype.handleModelReady = function () {
    var event = arguments[0];
    var slot =
      (event && event.detail && event.detail.kind) ||
      (this.viewer && this.viewer.getAttribute('data-model-kind')) ||
      this.pendingSlot;
    var scene = this.slotScenes[slot] || this.pendingScene;
    var requestedScene = this.pendingScene;

    this.currentSlot = slot;
    this.loadedScene = scene;
    if (requestedScene && scene !== requestedScene && this.activeScene === requestedScene) {
      this.configureModel(requestedScene);
      return;
    }

    if (scene === requestedScene) {
      this.pendingScene = '';
      this.pendingSlot = '';
    }
    if (scene === this.activeScene) {
      this.root.removeAttribute('data-model-loading');
      if (this.modelView) this.modelView.hidden = false;
      if (this.viewerControls) this.viewerControls.hidden = false;
      this.setMediaAccessibility('ready');
      this.setFallbackMessage('', false);
      this.resumeViewer();
    } else if (this.modelUrl(this.activeScene)) {
      this.configureModel(this.activeScene);
    }
  };

  GardenController.prototype.handleMotionChange = function () {
    if (this.prefersReducedMotion()) {
      this.pauseViewer(false);
      this.wasAutoRotating = false;
    }
  };

  GardenController.prototype.handleIntersection = function (entries) {
    var entry = entries && entries[0];
    if (!entry) return;

    this.isNearViewport = entry.isIntersecting;
    if (entry.isIntersecting) {
      if (this.modelUrl(this.activeScene)) {
        if (this.modelView) this.modelView.hidden = false;
        this.configureModel(this.activeScene);
      } else {
        this.resumeViewer();
      }
    } else {
      this.pauseViewer(true);
    }
  };

  GardenController.prototype.normalizeViewerState = function () {
    var hasError;
    var statusText;
    var progressMatch;

    if (!this.viewer) return;
    statusText = cleanString(this.viewerStatus && this.viewerStatus.textContent);
    progressMatch = statusText.match(/Loading 3D model(?:…|\.\.\.)?\s*(\d+%)?/i);
    if (this.viewerStatus && progressMatch) {
      this.viewerStatus.textContent =
        'Preparing the garden…' + (progressMatch[1] ? ' ' + progressMatch[1] : '');
    }

    hasError =
      this.viewer.classList.contains('q3d-has-error') ||
      Boolean(this.viewerStatus && this.viewerStatus.classList.contains('is-error'));

    if (hasError && this.activeScene === this.pendingScene) {
      this.root.removeAttribute('data-model-loading');
      if (this.modelView) this.modelView.hidden = true;
      if (this.viewerControls) this.viewerControls.hidden = true;
      this.setMediaAccessibility('fallback');
      this.setFallbackMessage(
        'This 3D view is temporarily unavailable. You can continue below.',
        true
      );
    }
  };

  GardenController.prototype.connect = function () {
    var queryHall;
    var success;

    if (this.connected) return;
    this.connected = true;
    this.root.addEventListener('click', this.handleClick);
    this.root.addEventListener('input', this.handleInput);
    this.root.addEventListener('change', this.handleInput);
    if (this.dedicationForm) {
      this.dedicationForm.addEventListener('submit', this.handleFormSubmit);
    }
    if (this.viewer) this.viewer.addEventListener('qiyuan:model-ready', this.handleModelReady);

    if (this.motionQuery) {
      if (this.motionQuery.addEventListener) {
        this.motionQuery.addEventListener('change', this.handleMotionChange);
      } else if (this.motionQuery.addListener) {
        this.motionQuery.addListener(this.handleMotionChange);
      }
    }

    if (global.IntersectionObserver) {
      this.intersectionObserver = new global.IntersectionObserver(this.handleIntersection, {
        rootMargin: '160px 0px',
        threshold: 0.01,
      });
      this.intersectionObserver.observe(this.root);
    }
    if (this.viewer && global.MutationObserver) {
      this.viewerObserver = new global.MutationObserver(
        this.normalizeViewerState.bind(this)
      );
      this.viewerObserver.observe(this.viewer, {
        attributes: true,
        attributeFilter: ['class', 'data-model-kind'],
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    if (this.durationField && isDuration(this.durationField.value)) {
      this.duration = this.durationField.value;
    }
    this.selectAction('lamp', false);
    this.showScene('garden');

    if (global.location && global.URLSearchParams) {
      queryHall = new global.URLSearchParams(global.location.search).get('qy_garden');
      if (isHall(queryHall)) this.enterHall(queryHall, false);
    }

    success = this.root.querySelector('[data-qy-contact-success]');
    if (success) {
      success.focus({ preventScroll: true });
      success.scrollIntoView({
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'center',
      });
    }
  };

  GardenController.prototype.disconnect = function () {
    if (!this.connected) return;
    this.connected = false;
    this.root.removeEventListener('click', this.handleClick);
    this.root.removeEventListener('input', this.handleInput);
    this.root.removeEventListener('change', this.handleInput);
    if (this.dedicationForm) {
      this.dedicationForm.removeEventListener('submit', this.handleFormSubmit);
    }
    if (this.viewer) this.viewer.removeEventListener('qiyuan:model-ready', this.handleModelReady);

    if (this.motionQuery) {
      if (this.motionQuery.removeEventListener) {
        this.motionQuery.removeEventListener('change', this.handleMotionChange);
      } else if (this.motionQuery.removeListener) {
        this.motionQuery.removeListener(this.handleMotionChange);
      }
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
    if (this.viewerObserver) {
      this.viewerObserver.disconnect();
      this.viewerObserver = null;
    }
  };

  function initializeRoot(root) {
    var controller = getController(root);

    if (controller) return controller;
    restoreParkedViewer(root);
    controller = new GardenController(root);
    setController(root, controller);
    controller.connect();
    return controller;
  }

  function init(scope) {
    if (!global.document) return [];
    return rootsWithin(scope || global.document).map(initializeRoot);
  }

  function destroy(scope) {
    rootsWithin(scope || global.document).forEach(function (root) {
      var controller = getController(root);
      if (controller) controller.disconnect();
      removeController(root);
    });
  }

  var api = {
    version: '2.2.0',
    init: init,
    destroy: destroy,
    isHall: isHall,
    getOffering: getOffering,
    buildLineItemProperties: buildLineItemProperties,
    buildCartPayload: buildCartPayload,
    source: SOURCE,
  };

  global.QiyuanEasternMemorialGarden = api;
  global.Qiyuan3DCoreEntrances = api;

  if (global.document && global.document.addEventListener) {
    global.document.addEventListener('shopify:section:unload', function (event) {
      parkViewers(event.target);
    });

    global.document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    if (global.document.readyState === 'loading') {
      global.document.addEventListener(
        'DOMContentLoaded',
        function () {
          init(global.document);
        },
        { once: true }
      );
    } else {
      init(global.document);
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
